import config from '../config';

//appends numbers with appropriate suffix
export const nth = (n: number, dontStyleSuffix?: boolean) =>
  `${n}${!dontStyleSuffix ? `<span class='num-suffix'>` : ''}${
    ['st', 'nd', 'rd'][(((((n < 0 ? -n : n) + 90) % 100) - 10) % 10) - 1] || 'th'
  }${!dontStyleSuffix ? `</span>` : ''}`;

//this makes updating of local storage easier
export const updateLocalStorage = (storageKey: string, newItems: any) => {
  //update localstorage
  const prevpageDetails = localStorage.getItem(storageKey) ? JSON.parse(localStorage.getItem(storageKey) ?? '{}') : undefined;

  if (prevpageDetails) localStorage.setItem(storageKey, JSON.stringify({ ...prevpageDetails, ...newItems }));
};

export const extractErrorMessage = (formStatus: any): string => {
  try {
    if (formStatus?.isError) {
      if (formStatus?.error?.status === 500) return 'Something went wrong. Please contact administrator.';
      else return formStatus?.error?.data?.response?.errors[0]?.message;
    }
    if (formStatus?.message) {
      const errMessage = formStatus?.message?.substring(0, formStatus?.message.indexOf('.') + 1);
      return errMessage;
    }
  } catch (error) {
    return 'Something went wrong. Please contact administrator.';
  }

  return 'No error found';
};

export const getFormattedPhone = (phone: string): string => {
  const phoneString = phone ? phone.replace(/[^0-9]+/g, '') : phone;
  return phone && phoneString.length >= 10
    ? `${phoneString.substring(0, 4)} ${phoneString.substring(4, 6)} ${phoneString.substring(6, 8)} ${phoneString.substring(
        8,
        10
      )}`
    : phone;
};

export const getAustStateAbbreviations = (state: string) => {
  switch (state) {
    case 'New South Wales':
      return 'NSW';
    case 'Northern Territory':
      return 'NT';
    case 'Queensland':
      return 'Qld';
    case 'South Australia':
      return 'SA';
    case 'Tasmania':
      return 'Tas';
    case 'Victoria':
      return 'Vic';
    case 'Western Australia':
      return 'WA';
    case 'Australian Capital Territory':
      return 'ACT';
    default:
      return state;
  }
};

export const getDecimalDisplay = (numtoDisplay: number) => {
  if (numtoDisplay) {
    const strnum = numtoDisplay.toLocaleString('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).split('.');
    return `$${strnum[0]}.<span>${strnum[1] ?? '00'}</span>`;
  } else {
    return `$ 0.<span>00</span>`;
  }
};

export const getFullName = (firstName: string, lastName: string) => {
  if (firstName && lastName) {
    const name =
      firstName[0].toUpperCase() +
      firstName.substr(1, firstName.length) +
      ' ' +
      lastName[0].toUpperCase() +
      lastName.substr(1, lastName.length);
    return name;
  } else {
    return 'No name';
  }
};

//this will round off the number into specific decimal places and return it as number still instead of turning into string
export const toDecimal = (value: number, decimalPlaces: number = 2) => {
  return Number(value.toFixed(decimalPlaces));
};

export const redirectLogin = () => {
  window.location.href = redirectLoginLink();
};

export const redirectLoginLink = (redirect: any = null) => {
  if (!redirect) {
    redirect = location.pathname;
    if (location.search) redirect += location.search;
  }

  return `${config.subsitesUrl.main}/login/redirect/${config.subsiteCode}?redirect=${encodeURIComponent(redirect)}`;
};

export const redirectCreateAccountLink = (redirect: any = null) => {
  if (!redirect) {
    redirect = location.pathname;
    if (location.search) redirect += location.search;
  }

  return `${config.subsitesUrl.main}/createaccount?redirect=${encodeURIComponent(redirect)}&subsite=dvr`;
};

export const chunkArray = (array: any[], size: number) => {
  const result = [];
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
};

export const mapInvoiceData = (userCheckoutData: any) => {
  const { biller, user_account, biller_acc_nos, user_invoice, user_resource_purchases } = userCheckoutData;
  let subscriber = {
    ...user_account,
  };

  if (user_account?.institution_profile && user_account?.user_profile)
    subscriber = {
      ...subscriber,
      first_name: user_account?.user_profile?.first_name,
      last_name: user_account?.user_profile?.last_name,
    };
  else if (user_account?.institution_profile) {
    subscriber = {
      ...subscriber,
      first_name: user_account?.institution_profile?.contact_person[0]?.name,
      last_name: '',
    };
  } else {
    subscriber = {
      ...subscriber,
      first_name: user_account?.user_profile?.first_name,
      last_name: user_account?.user_profile?.last_name,
    };
  }

  return {
    subscriber,
    biller_acc_nos,
    biller,
    subscription_invoice: {
      invoice_no: user_invoice?.invoice_no,
      is_pro_rata: false,
      pro_rata_amount: 0,
      user_payment: {
        sub_total_amount: userCheckoutData.sub_total_amount,
        tax_amount: userCheckoutData.tax_amount,
        total_amount: userCheckoutData.total_amount,
        created_at: user_invoice?.created_at,
      },
    },
    resource_purchases: user_resource_purchases
      ? user_resource_purchases.reduce((acc: any[], item: any) => {
          const existingItemIndex = acc.findIndex((p) => p.subsite_name === item.element_group_resource?.name);

          if (existingItemIndex !== -1) {
            acc[existingItemIndex].quantity += 1;
            acc[existingItemIndex].subtotal += item?.element_group_resource?.price;
          } else {
            acc.push({
              id: item?.element_group_resource?.id,
              subsite_name: item?.element_group_resource?.name,
              quantity: 1,
              price: item?.price,
              duration: item?.duration,
              subtotal: item?.price,
            });
          }

          return acc;
        }, [])
      : [],
  };
};

export const generatePageNumbers = (totalPages: number) => Array.from({ length: totalPages }, (_, i) => i + 1);

export const carouselItemNumbers = (screenWidth: number) => {
  if (screenWidth <= 785) {
    return 1;
  } else if (screenWidth <= 1081) {
    return 2;
  } else if (screenWidth <= 1385) {
    return 3;
  } else {
    return 4;
  }
};
